import React from 'react';
import LogoResizer from '@gin-betting/components/logo-resizer';

import GameLogo from '../GameLogo';

import './competitorLogo.scss';

interface Props {
    logoUrl: string | undefined;
    sportId: string;
}

const CompetitorLogo: React.FC<Props> = ({ logoUrl, sportId }) => {
    return logoUrl ? (
        <LogoResizer url={logoUrl} isOutsource={true}>
            {({ ref, bgImageStyle }) => (
                <div
                    styleName="logo"
                    className="__app-CompetitorLogo-logo"
                    style={bgImageStyle}
                    ref={ref}
                />
            )}
        </LogoResizer>
    ) : (
        <div styleName="logo" className="__app-CompetitorLogo-logo">
            <GameLogo gameId={sportId} />
        </div>
    );
};

export default CompetitorLogo;
